'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class MainHeaderComponent {
  currentUser = {};

  constructor(Auth, $state, pageSettings) {
    'ngInject';

    this.isLoggedIn = Auth.isLoggedInSync;
    this.isAdmin = Auth.isAdminSync;
    this.getCurrentUser = Auth.getCurrentUserSync;
    this.$state = $state;

    this.pageSettings = pageSettings.settings;
  }


  $onInit() {
    this.currentUser = this.getCurrentUser();
  }

  action() {
    let vm = this;
    vm.$state.go(vm.pageSettings.state, vm.pageSettings.stateParams);
  }
}

export default angular.module('directives.mainHeader', [])
  .component('mainHeader', {
    template: require('./main-header.pug'),
    controller: MainHeaderComponent,
    controllerAs: 'vm'
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/main-header/main-header.component.js